import { httpRequest } from "../../../utils/HttpRequest";
import { IPurchasePlanSearch, IPurchasePlanDetail, IPurchasePlanFields, Detailed, IPurchasePlanList, IPurchasePlanStatistics } from "./purchasePlanType"
class PurchasePlanService {
    async page(searchVo: IPurchasePlanSearch) {
        const apiUrl = "/zzw-vrm/purchase/plan/findPage";
        return await httpRequest.post<IPurchasePlanList>(apiUrl, searchVo);
    }
    async total(searchVo: IPurchasePlanSearch) {
        const apiUrl = "/zzw-vrm/purchase/plan/total";
        return await httpRequest.post<IPurchasePlanStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/purchase/plan/findById/${id}`;
        return await httpRequest.get<IPurchasePlanDetail>(apiUrl);
    }

    async insert(insertVo: IPurchasePlanFields) {
        const apiUrl = "/zzw-vrm/purchase/plan/insert";
        return await httpRequest.post<IPurchasePlanDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchasePlanFields) {
        const apiUrl = "/zzw-vrm/purchase/plan/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    async findTransferwarehouse(val: any) {
        const apiUrl = "/zzw-vrm/purchase/getMaterialShelfs";
        return await httpRequest.post<any>(apiUrl, val);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/zzw-vrm/purchase/plan/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: IPurchasePlanSearch) {
        const apiUrl = "/zzw-vrm/purchase/plan/export";
        return await httpRequest.postFile(apiUrl, params);
    }
    //明细导出
    async exportDetail(params: IPurchasePlanSearch) {
        const apiUrl = "/zzw-vrm/purchase/plan/detailsExport";
        return await httpRequest.postFile(apiUrl, params);
    }
    //转采购单
    async transfer(planCode: string) {
        const apiUrl = `/zzw-vrm/purchase/plan/transfer/${planCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // //详情导入
    // async import(){
    //     const apiUrl = "/zzw-vrm/purchase/plan/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        // const apiUrl = "/zzw-vrm/purchase/plan/detail/downloadTpl";
        const apiUrl = "/zzw-vrm/purchase/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //登记导出
    async arrivalExport(planCode: any) {
        const apiUrl = `/zzw-vrm/purchase/plan/arrivalExport/${planCode}`;
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/zzw-vrm/purchase/plan/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
}

export const purchasePlanService = new PurchasePlanService();